module.exports = __webpack_public_path__ + "static/img/suanfa.68b9e4ef.png";